import React, { useState } from "react";
import Banner from "../../Components/Common/Banner";

const Faq = () => {
  const [faqs, setFaqs] = useState([
    {
      question: "How do I create an account on the website?",
      answer: `To create an account, click on the "Sign Up" button located at the top right corner of the homepage. Fill out the required information, including your name, email address, and password. Click "Create Account" to complete the registration process.`,
      isOpen: true,
    },
    {
      question: "What payment methods do you accept?",
      answer: `We accept several payment methods for your convenience, including credit cards (Visa, Mastercard, American Express), PayPal, and Apple Pay.`,
      isOpen: false,
    },
    {
      question: "How long does shipping take?",
      answer: `Shipping times may vary depending on your location and the product you ordered. We strive to process and ship orders within 1-2 business days after payment confirmation.`,
      isOpen: false,
    },
  ]);

  const toggleFaq = (index) => {
    setFaqs(
      faqs.map((faq, i) =>
        i === index ? { ...faq, isOpen: !faq.isOpen } : { ...faq, isOpen: false }
      )
    );
  };

  return (
    <div>
      <Banner pageName="FAQ" breadcrummbs="Home / Faq" />
      <div className="lg:px-16 md:px-10 px-5 py-10">
        <section id="faq" className="container relative">
          <h3 className="mb-14 text-primaryDarkColor text-center text-3xl font-semibold  xl:text-4xl">
            Frequently Asked Questions
          </h3>
          {faqs.map((faq, index) => (
            <div className="m-6" key={index}>
              <div
                className={`rounded w-full cursor-pointer select-none px-4 py-4  transition duration-300 ${
                  faq.isOpen
                    ? "bg-primaryOrangeColor text-white"
                    : "bg-gray-300/80 border-2 border-teal-600/30"
                }`}
                onClick={() => toggleFaq(index)}
              >
                <h4 className="text-lg font-medium">{faq.question}</h4>
              </div>
              <div
                className={`faq-answer transition-max-height duration-500 ease-in-out overflow-hidden ${
                  faq.isOpen ? "max-h-96 p-4 border-dashed border-orange-600/30" : "max-h-0 p-0"
                } border-x-2 border-b-2  bg-orange-100/50 text-orange-800`}
              >
                <h5>{faq.answer}</h5>
              </div>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default Faq;
